export const AppMenuConfig = {
  capa : {
    logoMini : 'assets/images/CLHUB_Logo_Large.png',
    logoLarge : 'assets/images/CLHUB_Logo_Large.png',
      color : '#003b5c',
      menu: false
  },
  powerBi : {
      logoMini : 'assets/images/CLHUB_Logo_Large.png',
      logoLarge : 'assets/images/CLHUB_Logo_Large.png',
      color : '#003b5c',
      menu: true
  }
};
